import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Form, Formik } from 'formik';
import { StorageRoom } from '../../../models/Storage/StorageRoom';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { ButtonPrimary } from '../../components/Button/ButtonPrimary';
import { ErrorMessageLabel } from '../../components/ErrorMessageLabel/ErrorMessageLabel';
import { InputField } from '../../components/InputField/InputField';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom';

function EditStorageRoom() {
  const { id } = useParams();
  const navigate = useNavigate();
  const client = useQueryClient();

  const { data: storageRoom, isLoading } = useQuery(
    ['storage-room', id],
    () => StorageRoom.get(Number(id)),
    { enabled: !!id }
  );

  if (isLoading) return <h1>Loading...</h1>;

  return (
    <>
      <h1 className="cs-title">Izmena skladišne sobe</h1>
      <Row>
        <Formik
          initialValues={{ name: storageRoom?.name ?? '' }}
          enableReinitialize
          validationSchema={Yup.object({
            name: Yup.string().required('Naziv je obavezan')
          })}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            storageRoom
              ?.update(values)
              .then(() => {
                client.invalidateQueries(['storage-rooms']);
                toast.success('Soba izmenjena!');
                navigate('/admin/storage-rooms/list');
              })
              .catch((error) => {
                toast.error(
                  error?.response?.data?.message || 'Greška pri izmeni.'
                );
              })
              .finally(() => setSubmitting(false));
          }}
        >
          {({ isSubmitting }) => (
            <Form autoComplete="off" className="cs-form-wrapper">
              <FormGroup>
                <Col lg={6}>
                  <FormLabel>Naziv sobe</FormLabel>
                  <InputField placeholder="Naziv sobe" name="name" />
                  <ErrorMessageLabel name="name" />
                </Col>
              </FormGroup>
              <ButtonPrimary type="submit" disabled={isSubmitting}>
                Sačuvaj
              </ButtonPrimary>
            </Form>
          )}
        </Formik>
      </Row>
    </>
  );
}

export default EditStorageRoom;
